import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormSelectField from 'components/ui/form/FormSelectField';
import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';
import { memo } from 'react';

const validationSchema = yup.object({
  name: yup.string().required('Nom kiritish majburiy!'),
  object_id: yup.string().required('Obyekt tanlash majburiy!'),
  user_id: yup.string().required("Mas'ul xodim tanlash majburiy!"),
});

const AddEditModal = (props) => {
  const { open, setOpen, setRefetch, itemId } = props;
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      name: '',
      user_id: '',
      object_id: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (itemId)
        submit(
          { type: 'post', contentType: 'simple' },
          values,
          `admin/account/income/${itemId}`,
          values.name,
          itemId,
          true,
          handleFinishRequest
        );
      else
        submit(
          { type: 'post', contentType: 'simple' },
          values,
          `admin/accounts`,
          values.name,
          itemId,
          false,
          handleFinishRequest
        );
    },
  });

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='md'
      PaperProps={{
        className: '!base-border !shadow-none',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !bg-gray-100 !mb-2'
      >
        <span>Kassa yaratish</span>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            {' '}
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormSelectField
                delay={0}
                label={"Mas'ul xodim"}
                fieldName={'user_id'}
                formik={formik}
                path={'/dictionary/staffs'}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormTextField
                delay={0.3}
                label={'Nomi'}
                fieldName='name'
                formik={formik}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormSelectField
                delay={0}
                key={'object_id'}
                label={'Obyekt'}
                fieldName={'object_id'}
                formik={formik}
                path={'/dictionary/objects'}
              />
            </Grid>
            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.4}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(AddEditModal);
